import { inject } from '@angular/core';
import { CanActivateFn, Params, Router } from '@angular/router';
import { TypeCheck } from '../../shared/utility/constants';
import {
  BreadcrumbNavigationService,
  FROM_DASHBOARD_STATE_KEY,
  DASHBOARD_TYPE_STATE_KEY,
  DASHBOARD_QUERY_PARAMS_STATE_KEY,
} from '../../shared/services/breadcrumb-navigation.service';

export const breadcrumbFromDashboardGuard: CanActivateFn = () => {
  const breadcrumbNav = inject(BreadcrumbNavigationService);
  const router = inject(Router);
  const nav = router.getCurrentNavigation();
  const state = (nav?.extras?.state || {}) as Record<string, unknown>;
  const fromDashboard = !!state[FROM_DASHBOARD_STATE_KEY];
  const dashboardType =
    typeof state[DASHBOARD_TYPE_STATE_KEY] === TypeCheck.string
      ? (state[DASHBOARD_TYPE_STATE_KEY] as string)
      : undefined;
  const rawQueryParams = state[DASHBOARD_QUERY_PARAMS_STATE_KEY];
  const queryParams =
    rawQueryParams && typeof rawQueryParams === 'object'
      ? (rawQueryParams as Params)
      : undefined;
  breadcrumbNav.setFromDashboard(fromDashboard, dashboardType, queryParams);
  return true;
};
